import * as types from './constants';

// Get Codes
export const getCodesRequest = data => (
  { type: types.GET_CODES_REQUEST, payload: data }
);

export const getCodesDone = data => (
  { type: types.GET_CODES_DONE, payload: data }
);

export const getCodesFailed = errors => (
  { type: types.GET_CODES_FAILED, payload: errors }
);

export const getCodesReset = () => (
  { type: types.GET_CODES_RESET }
);

// Operations
export const toggleCode = data => (
  { type: types.TOGGLE_CODE, payload: data }
);

export const toggleAllCodes = data => (
  { type: types.TOGGLE_ALL_CODES, payload: data }
);

export const setFilter = data => (
  { type: types.SET_CODES_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_CODES_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_CODES_FILTERS, payload: { filterToUpdate, mobile } }
);

export const codesSetPage = data => (
  { type: types.CODES_SET_PAGE, payload: data }
);